import { combineReducers } from 'redux';
import { CampaignTabSection, OverviewTabSection } from 'modules/iterableGoals/types';

import { goalPerformanceReducer } from './goalPerformanceReducer';
import { completionsVsSendsReducer } from './completionsVsSendsReducer';
import { performantCampaignReducer } from './performantCampaignsReducer';
import { goalContributionsByMediumReducer } from './goalContributionsByMediumReducer';
import { campaignContributionsReducer } from './campaignContributionsReducer';

export const goalAnalyticsReducer = combineReducers({
  [OverviewTabSection.CAMPAIGN_PERFORMANCE]: performantCampaignReducer,
  [OverviewTabSection.GOAL_CONTRIBUTIONS_BY_MEDIUM]: goalContributionsByMediumReducer,
  [OverviewTabSection.COMPLETION_VS_SENDS]: completionsVsSendsReducer,
  [OverviewTabSection.GOAL_PERFORMANCE]: goalPerformanceReducer,
  [CampaignTabSection.CAMPAIGN_CONTRIBUTION]: campaignContributionsReducer,
});
